import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { GET, POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import PageHeader from "../../admin/pageHeader/pageheader";

function LeaveDetailsAdmin() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [employeeData, setEmployeeData] = useState<any>([]);
  const navigate = useNavigate();

  // const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const columns = [
    {
      dataIndex: "type",
      title: "Type",
    },
    {
      dataIndex: "approver",
      title: "Approver",
    },
    {
      dataIndex: "from",
      title: "From",
      render: (from: any) => (from ? moment(from).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "to",
      title: "To",
      render: (to: any) => (to ? moment(to).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: any) => {
        let color = "";
        switch (status?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{status}</span>;
      },
    },
    {
      dataIndex: "employeeId",
      title: "Employee",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "description",
      title: "Description",
    },
    {
      dataIndex: "createdBy",
      title: "Created By",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/leave-update/${record.id}`)} // Use navigate with a route
          />
        </Space>
      ),
    },
  ];

  const submitHandler = async (values: any) => {
    try {
      const obj = {
        employeeId: values.employeeId,
        salaryId: values.salaryId,
        leaveId: values.leaveId,
        approver: values.approver,
        from: values.from?.format("YYYY-MM-DD"),
        to: values.to?.format("YYYY-MM-DD"),
        type: values.type,
        status: values.status,
        description: values.description,
        createdBy: values.createdBy,
      };

      setIsLoading(true);
      const api = API.CREATE_LEAVE;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "Leave created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchLeave(page, pageSize);
      } else {
        notification.error({ message: "Something went wrong!" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const fetchLeave = async (page: any, pageSize: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: pageSize,
      };
      const url = API.LIST_LEAVE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeave(page, pageSize);
    fetchEmployee();
  }, [page, pageSize]);

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const data: any = await GET(url, {});
      if (data?.data) {
        setEmployeeData(data?.data);
      } else {
        console.error("Unexpected data format:", data);
        setEmployeeData([]); // Set to an empty array to prevent errors
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]); // Handle errors by setting to an empty array
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageHeader>
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Col>
            <Button
              type="primary"
              onClick={showModal}
              style={{ marginRight: "10px" }}
            >
              Create Leave
            </Button>
          </Col>
        </Row>
      </PageHeader>

      <Modal
        title="Create Leave"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              {employeeData && (
                <Form.Item
                  label=" Name"
                  name="employeeId"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select an Name" size="large">
                    {employeeData?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>

            <Col sm={6}>
              <Form.Item
                name="from"
                label="From"
                rules={[{ required: true, message: "Select start date" }]}
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="to"
                label="To"
                rules={[{ required: true, message: "Select end date" }]}
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: "Enter description" }]}
              >
                <Input.TextArea placeholder="Description" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="type"
                label="Leave Type"
                rules={[{ required: true, message: "Select leave type" }]}
              >
                <Select placeholder="Select leave type">
                  <Select.Option value="sick">Sick</Select.Option>
                  <Select.Option value="vacation">Vacation</Select.Option>
                  <Select.Option value="maternity">Maternity</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="createdBy"
                label="Created By"
                rules={[{ required: true, message: "Enter creator name" }]}
              >
                <Select placeholder="Select ">
                  <Select.Option value="hr">Hr</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Select status" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create Leave
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: meta?.total,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />
    </>
  );
}

export default LeaveDetailsAdmin;
